module.exports = __webpack_public_path__ + "img/16m002-09.c5492f81.jpg";